<template>
  <div class="overlay" :class="classObject" @click="hide"></div>
</template>

<script src="./overlay.js"></script>
<style src="./overlay.scss" lang="scss"></style>
